import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Row, Form } from "react-bootstrap";
import { runInnerFunction } from "../../compatManager";
import { getDataReader, getNodes, RPWDataReader } from "../../livedataFuncs";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject } from "../../redux/reducer";
import { store } from "../../redux/store";
import Loading from "../Loading";
import { CreatePIPS, delay, removeHeaderFooter } from "./PipsFuncs";

async function initPips(sid: string, livedataRoot): Promise<string> {
    let node: ajaxslt.XNode[] = getNodes(livedataRoot, 'TPAppXML');
    let pipformid: string = await CreatePIPS(sid, node[0]);
    if (pipformid > '')
        runInnerFunction('SetPageDirty', null);
    return pipformid;

}

async function login(iframe: HTMLIFrameElement, username: string, teraviewNumber: string, setAttemptedLogin: (flag: boolean) => void): Promise<void>{
    let iDocument = null;
    if (iframe !== null && iframe !== undefined) {
        iDocument = iframe.contentWindow.document;
        let usernameField = iDocument.getElementById('j_username');
        let tvNumberField = iDocument.getElementById('j_tvnumber');
        if ((usernameField !== null && usernameField !== undefined) || (tvNumberField !== null && tvNumberField !== undefined)) { // account login name or tv number field is on the screen
            if (username > '' && teraviewNumber > '') {
                usernameField.value = username;
                tvNumberField.value = teraviewNumber;
                let loginbtn = iDocument.getElementById('btn-login');
                loginbtn.click(); // login 
                setAttemptedLogin(true);
            }
        }
    }
}

function saveAndExit(iframe: HTMLIFrameElement) : void{ // press save and exit on screen
    if (iframe !== null && iframe !== undefined) {
        var buttonsArray: any = iframe.contentDocument.querySelectorAll('Button');
        for (let i = 0; i < buttonsArray.length; i++) {
            if (buttonsArray[i].innerText === 'Save and Exit') {
                buttonsArray[i].click();
                return;
            }
        }
    }
}
async function loadExistingPIP(iframe, pipformid: string, setShowiFrame: (flag: boolean) => void, showiFrame: boolean, DataReaderObj: RPWDataReader, setPipConfirmationNumberCreated: (flag: boolean) => void) : Promise<void> {
    if (pipformid > '') {
        iframe.src = `${window.location.origin}/csp/land-transfer-tax-info?id=${pipformid}`;

        if (iframe !== null && iframe !== undefined) { // add event listener on submit button
            var buttonsArray = iframe.contentDocument.querySelectorAll('Button');
            for (let i = 0; i < buttonsArray.length; i++) {
                if (buttonsArray[i].innerText === 'Submit') { // if submit clicked
                    buttonsArray[i].addEventListener('mouseup', submitButtonClick(iframe, DataReaderObj, setShowiFrame, setPipConfirmationNumberCreated));
                    continue;
                }
            }
        }
        removeHeaderFooter(iframe,showiFrame);
    }
}

async function submitButtonClick(iframe, DataReaderObj:RPWDataReader , setShowiFrame: (flag: boolean) => void, setPipConfirmationNumberCreated: (flag: boolean) => void) : Promise<void> {
    await delay(2000);
    if (typeof iframe.contentWindow.openMOFReport === 'function') {
        let openMOFReportString: string = iframe.contentWindow.openMOFReport.toString();
        let pipconfirmationid: string = openMOFReportString.match(/'([^']+)'/)[1];
        DataReaderObj.setPIPConfirmnationNumber(pipconfirmationid);
        setPipConfirmationNumberCreated(true);
        runInnerFunction('SetPageDirty', null);
        let pipconfirm = DataReaderObj.getPIPConfirmnationNumber()
        if (pipconfirm !== '' && pipconfirm !== null && pipconfirm !== undefined) {
            setShowiFrame(false);
        }
    }
}

const Pips = () => {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let teraviewAcc: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'AccountName');
    let username: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'Account');
    let teraviewNumber: string = DataReaderObj.getThirdPartyAccountAttribute('TeranetExpress', 'TVNumber');
    let initialPIPFormID: string = DataReaderObj.getPIPFormID();
    let pipConfirmationNumber: string = DataReaderObj.getPIPConfirmnationNumber();
    const [pipformid, setPipformid] = useState('No form created');
    const [pipConfirmnationNumberState, setPipConfirmnationNumberState] = useState<string>('');
    const [pipConfirmationNumberCreated, setPipConfirmationNumberCreated] = useState<boolean>(false);
    const [isLoggedin, setIsLoggedin] = useState<boolean>(null);
    const [showiFrame, setShowiFrame] = useState<boolean>(false);
    const [showNoResultsFoundError, setShowNoResultsFoundError] = useState<boolean>(false);
    const [attemptedLogin, setAttemptedLogin] = useState<boolean>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const sessionId = useAppSelector((state: lddStateObject) => state.SessionID);

    if (initialPIPFormID !== pipformid && initialPIPFormID !== null) {
        setPipformid(initialPIPFormID);
    }
    if (pipConfirmationNumber !== pipConfirmnationNumberState && pipConfirmationNumber !== null) {
        setPipConfirmnationNumberState(pipConfirmationNumber);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
            removeHeaderFooter(iframe,showiFrame);
            let currentHref: string = iframe.contentWindow.location.href;
            let formidw = iframe.contentWindow.document.getElementById('pinPrefix'); // pin prefix 
            if (
                (!(currentHref.includes('/csp/land-transfer-tax-info?id=')) && !(currentHref.includes('/csp/land-transfer-tax-info-success')) && !(currentHref.includes('/csp/land-transfer-tax-info#')) && (formidw === null || formidw === undefined))
                ||
                (currentHref.includes('/csp/land-transfer-tax-info-login-failure'))
                ||
                (currentHref.includes('/csp/land-transfer-tax-info-home'))
            ) {
                setShowiFrame(false);
            } else if((formidw && currentHref.includes('/csp/land-transfer-tax-info?id='))){
                setShowiFrame(false);
                setShowNoResultsFoundError(true);
            } else {
                setShowNoResultsFoundError(false);
                setShowiFrame(true);
            }
            if (currentHref.includes('/csp/land-transfer-tax-info-home')) {
                setIsLoggedin(true);
            } else if (currentHref.includes('/csp/land-transfer-tax-info-login-failure')) {
                setIsLoggedin(false);
            }
        }, 1000);
        return () => clearInterval(interval);
    })

    return (
        <>
            {isLoading ? <Loading /> : null}
            <Card>
                <Card.Header>
                    <Card.Title>Prescribed Information for the Purposes of Section 5.0.1 Form (PIPS)</Card.Title>
                </Card.Header>

                <Card.Body>
                    <Row>
                        <Col>
                            <Alert>Submitting and opening of forms may take a few minutes to load. After loading, the form will appear to complete the submission process. Please note that this integration is only available during <a href="https://www.teraview.ca/en/hours-of-service/" target="_blank" rel="noopener noreferrer">Teraview<sup>&#174;</sup>'s hours of service</a></Alert>
                        </Col>
                    </Row>
                    {
                        (teraviewAcc <= '' || teraviewAcc === null || teraviewAcc === undefined)
                            ||
                            (username <= '' || username === null || username === undefined)
                            ||
                            (teraviewNumber <= '' || teraviewNumber === null || teraviewNumber === undefined)
                            ?
                            <Row>
                                <Col>
                                    <Alert variant="danger">Your Teraview<sup>&#174;</sup> credentials are incorrect. Please review this in User Settings and 3rd Party Accounts.</Alert>
                                </Col>
                            </Row>
                            :
                            null
                    }
                    {
                        showNoResultsFoundError ?
                            <Alert variant="danger">The form number could not be found. Please create a new form.</Alert>
                            :
                            null}
                    {
                        isLoggedin ?
                            <>
                                <Row>
                                    <Col className="col-4">
                                        <Form.Group>
                                            <Form.Label>PIPS Form ID</Form.Label>
                                            <Form.Control id="PIPFormIDInput" value={pipformid} disabled></Form.Control>
                                            {pipformid === 'No form created' ?
                                                null
                                                :
                                                <Button
                                                    onClick={() => {
                                                        let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                                        saveAndExit(iframe);
                                                        loadExistingPIP(iframe, pipformid, setShowiFrame, showiFrame, DataReaderObj, setPipConfirmationNumberCreated);
                                                    }}>
                                                    Open
                                                </Button>
                                            }
                                            <Button
                                                onClick={async () => {
                                                    setIsLoading(true);
                                                    var ret = await initPips(sessionId, dataRoot);
                                                    if (ret !== undefined) {
                                                        setPipformid(ret);
                                                    }
                                                    let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                                    saveAndExit(iframe);
                                                    loadExistingPIP(iframe, ret, setShowiFrame, showiFrame, DataReaderObj, setPipConfirmationNumberCreated);
                                                    setIsLoading(false);
                                                }
                                                }>
                                                Create New
                                            </Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                            :
                            null
                    }
                    {
                        isLoggedin === false && attemptedLogin ?
                            <Alert variant="danger">
                                Your Teraview<sup>&#174;</sup> credentials are incorrect. Please review this in User Settings.
                            </Alert> :
                            null
                    }
                    {
                        pipConfirmnationNumberState !== '' && pipConfirmnationNumberState !== null && pipConfirmnationNumberState !== undefined ?
                            // true ?
                            <>
                                <Form.Group>
                                    <Form.Label>PIPS Confirmation Number</Form.Label>
                                    <Form.Control id="PIPConfirmnation" value={pipConfirmnationNumberState} disabled />
                                </Form.Group>

                                {pipConfirmationNumberCreated ?
                                    <Alert variant={'warning'}>
                                        Please save the document on the screen below and LDD file before proceeding. Otherwise, you will lose the PIPS confirmation number and the document will be lost.
                                    </Alert>
                                    :
                                    null}

                            </>
                            :
                            null
                    }

                    <iframe
                        title="pipScreen"
                        id="pipScreen"
                        src={`${window.location.origin}/csp/land-transfer-tax-info-login`}
                        style={{
                            width: '100%',
                            overflow: 'auto',
                            height: showiFrame && (showNoResultsFoundError !== true) ? '2400px' : '0px',
                        }}
                        scrolling={"no"}
                        onLoad={async () => {
                            if (!isLoggedin) {
                                let iframe = document.getElementById('pipScreen') as HTMLIFrameElement;
                                await login(iframe, username, teraviewNumber, setAttemptedLogin);
                            }
                        }
                        }
                        onBlur={
                            () => {
                                runInnerFunction('SetPageDirty', null);
                            }
                        }
                    >
                    </iframe>
                </Card.Body>
            </Card>
        </>
    )
}

export default Pips;